import React from "react";
import Layout from "../components/Layout";
import Products from "../components/Products";
import Form from "../components/Form";

export default function Home() {
  return (
    <Layout>
      <div className="productWrapper">
        <Products />
        <Form />
      </div>
    </Layout>
  );
}
